export const powerMaxConsumptionDaily = {
    powerMaxConsumptionDailyLineDiagrammMonatsleistungClass: {
        url: "Diagramm/powerconsumptionline",
        defaultSegment: "Diagramm",
        forceRefresh: false,
        receiveType: 'RECEIVE_LineDiagrammMonatsLeistung_powerMaxConsumptionDailyReducer'
    }
};